import React, { useState, useEffect } from 'react';
import api from '../../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const LocalEstoqueModal = ({ onClose, local, onLocalEstoqueAtualizado }) => {
    const [tituloModal, setTituloModal] = useState("");
    const [formData, setFormData] = useState({
        nome: ''
    });

    useEffect(() => {
        if (local != null) {
            setFormData({
                ...local,
            });
            setTituloModal('Editar Local de Estoque');
        }
        else setTituloModal('Novo Local de Estoque');
    }, [local]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.nome == '') {
            Swal.fire('Erro', 'Por favor, preencha o Nome.', 'error');
            return;
        }
        
        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (local != null) {
                await api.put(`/localEstoques/${local.id}`, formData);
            }
            else {
                await api.post(`/localEstoques`, formData);
            }

            onLocalEstoqueAtualizado();
            onClose();
            Swal.fire('Sucesso', 'Local de estoque salvo com sucesso!', 'success');
        }
        catch (error) {
            Swal.close();
            Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Nome</label>
                                    <input
                                        type="text"
                                        name="nome"
                                        className="form-control"
                                        value={formData.nome}
                                        autoComplete="off"
                                        onChange={(e) => setFormData({ ...formData, nome: e.target.value.toUpperCase() })}
                                        required
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default LocalEstoqueModal;
